import { useCheckoutStateStore } from '../components/checkout/stores/checkoutStateStore';
import { useOrderTypeStore } from '../components/shoppingCart/stores/orderTypeStore';
import { useShoppingCartStore } from '../components/shoppingCart/stores/shoppingCartStore';
import { resolveOrderTypeWarehouseCode } from './resolveOrderTypeWarehouseCode';

/**
 * The one seam both submit buttons ("Til kassen" and "Bekreft ordre") call
 * through to re-verify stock immediately before submit. Knows nothing about
 * which button called it, navigation, or the customer-info form.
 */
export function useStockValidation() {
  const checkoutStateStore = useCheckoutStateStore();
  const orderTypeStore = useOrderTypeStore();
  const shoppingCartStore = useShoppingCartStore();

  async function verifyStock(): Promise<boolean> {
    const warehouseCode = await resolveOrderTypeWarehouseCode(orderTypeStore.orderType);
    await checkoutStateStore.refetchCartForOrderType(warehouseCode);

    const hasInsufficientStock = shoppingCartStore.insufficientStockLineItems.length > 0;
    if (hasInsufficientStock) {
      shoppingCartStore.stockSummaryVisible = true;
    }

    return !hasInsufficientStock;
  }

  return { verifyStock };
}
